// @ts-nocheck
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { UtilsDataService } from "src/app/services/utils-data.service";
import { VendorService } from "src/app/services/vendor.service";
import { HeaderLatestComponent } from "src/app/home/landing-root/header-latest/header-latest.component";
import { PeopleflowFooterComponent } from "src/app/peopleflow-footer/peopleflow-footer.component";

@Component({
  selector: "app-vendor-success-page",
  templateUrl: "./vendor-success-page.component.html",
  styleUrl: "./vendor-success-page.component.scss",
  standalone: true,
  imports: [CommonModule, HeaderLatestComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class VendorSuccessPageComponent {
  [key: string]: any;
  constructor() {}

  ngOnInit(): void {}

  goTo(link: any) {}
}
